<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import type { CourseTrainer } from "../../courseTrainers.js";

	const { tenant } = getGlobalTemplateProps();
	const { trainer }: { trainer: CourseTrainer } = $props();
</script>

<article class="flex flex-col sm:flex-row gap-5 sm:gap-6 md:gap-8">
	<img
		src={trainer.image.src}
		alt={trainer.name}
		width={trainer.image.width}
		height={trainer.image.height}
		loading="lazy"
		class="w-40 sm:w-44 md:w-52 aspect-[3/4] shrink-0 rounded-2xl object-cover bg-fcrlightgray-400"
	/>
	<div class="flex flex-col">
		<div class="uppercase text-fcrorange font-bold tracking-[.1em] text-xs">
			<Formatted text={trainer.city[tenant.locale]} />
		</div>
		<Heading level={3} text={trainer.name} class="font-antipol font-medium text-6/tighter text-fcrdarkgray mt-2" />
		<p class="mt-3 text-sm/normal sm:text-base text-fcrgray">
			<Formatted text={trainer.bio[tenant.locale]} />
		</p>
	</div>
</article>
